"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgPencilAlt(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M18.128 0a.767.767 0 01.541.224l5.107 5.107a.766.766 0 01.224.541l-.006-.095a.77.77 0 01.006.072V12c0 .203-.08.398-.224.542L12.696 23.62l-.033.054a.764.764 0 01-.406.28A.745.745 0 0112 24H.766A.766.766 0 010 23.234V11.978a.77.77 0 01.224-.52l-.069.08a.76.76 0 01.084-.094L11.46.224A.766.766 0 0112 0zM1.53 21.161v1.307l1.308.001a3.36 3.36 0 00-.572-.736 3.36 3.36 0 00-.736-.572zm.29-8.776a6.468 6.468 0 00-.29.106V19.5c.559.157 1.184.516 1.82 1.15.634.636.992 1.261 1.15 1.82h7.048c.036-.091.075-.193.113-.306.302-.88.4-1.78.185-2.588a3.016 3.016 0 00-.733-1.309 4.247 4.247 0 00-.91-.733 4.854 4.854 0 00-1.566-.598A4.28 4.28 0 008 16.853l-.078-.002H7.91l-.034-.003-.057-.002-.01-.001.101.006a.772.772 0 01-.202-.027l-.012-.005a.752.752 0 01-.316-.185l-.01-.01a.77.77 0 01-.055-.062l-.01-.013a.769.769 0 01-.097-.167l-.011-.03a.67.67 0 01-.041-.161v-.007l-.003-.016a.776.776 0 01-.004-.072l.001-.029-.003-.058a4.147 4.147 0 00-.086-.625A4.823 4.823 0 006.43 13.8a4.349 4.349 0 00-.712-.866 3.017 3.017 0 00-1.31-.733c-.806-.215-1.706-.117-2.587.185zM22.468 7.72l-9.898 9.9c.358.477.608 1 .757 1.561.13.486.18.98.167 1.476l8.974-8.976V7.72zm-4.34-5.871L7.435 12.542l-.008.008c.107.14.207.286.3.435.527.84.795 1.676.9 2.384a6.26 6.26 0 012.851 1.176L22.151 5.872l-4.023-4.023zm-1.849-.318h-3.962l-9.024 9.023a5.165 5.165 0 011.51.166 4.514 4.514 0 011.544.745l.005-.007 9.927-9.927z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgPencilAlt;
exports.default = _default;